import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { brandListFailure, brandListSuccess } from '../../actions/brandActions/brandListActions';
import store from '../../configStore';

function* brandList({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getBrandListByStatus + payload.statusFilter,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("BRAND_LIST_SUCCESS status :", response.data.status);
        console.log("BRAND_LIST_SUCCESS data :", response.data.response);
        console.log("BRAND_LIST_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            brandListSuccess({
                status: response?.data?.status,
                authStatus: response?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("BRAND_LIST_FAILURE status :", error?.response?.status);
        console.log("BRAND_LIST_FAILURE data:", error?.response?.data);
        console.log("BRAND_LIST_FAILURE error :", error);
        console.log('====================================');
            yield put(brandListFailure({
            status: error?.response?.data?.status,
            authStatus: error?.response?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* brandListSaga() {
    yield takeLatest(actionTypes.BRAND_LIST_REQUEST, brandList);
}

export default brandListSaga;
